import React, { useEffect } from 'react';
import axios from 'axios';
import Grid from '@mui/material/Unstable_Grid2';

import './../styles/sheepskin-floor-mats.css'

import ColorSwatches from '../components/color-swatches';
import InfoTabs from '../components/info-tabs';
import CartButtons from '../components/cart-buttons';
import ProductInfo from '../components/product-info';
import FloorMatCarSelector from '../components/floor-mat-car-selector';
import { useSheepskinFloormatStore } from '../stores/sheepskin-floormat-store';
import ProductOptions from '../components/product-options';
import { formatMoney } from '../utils/helpers';

function SheepskinFloorMats() {
  const colors = useSheepskinFloormatStore(state => state.colors);
  const selectedCar = useSheepskinFloormatStore(state => state.selectedCar);
  const setSelectedCar = useSheepskinFloormatStore(state => state.setSelectedCar);
  const selectedColor = useSheepskinFloormatStore(state => state.selectedColor);
  const setSelectedColor = useSheepskinFloormatStore(state => state.setSelectedColor);
  const productVariant = useSheepskinFloormatStore(state => state.productVariant);
  const setProductVariant = useSheepskinFloormatStore(state => state.setProductVariant);
  const quantity = useSheepskinFloormatStore(state => state.quantity);
  const setQuantity = useSheepskinFloormatStore(state => state.setQuantity);
  const tabs = useSheepskinFloormatStore(state => state.tabs);
  const productOptions = useSheepskinFloormatStore(state => state.productOptions);
  const selectedProductOption = useSheepskinFloormatStore(state => state.selectedProductOption);
  const setSelectedProductOption = useSheepskinFloormatStore(state => state.setSelectedProductOption);

  const productImage = productVariant?.featured_image?.src;

  const addToCart = async () => {
    // console.log('addToCart selectedCar', selectedCar);

    if (productVariant?.id && quantity > 0) {

      console.log('productVariant', productVariant);

      const params = {
        items: [{
          id: productVariant.id,
          quantity,
          properties: {
            Car: `${selectedCar?.year} ${selectedCar?.make?.makeName} ${selectedCar?.model?.modelName} ${selectedCar?.submodel || ''}`,
            Make: selectedCar?.make?.makeName,
            Model: selectedCar?.model?.modelName,
            Trim: selectedCar?.submodel,
            base_vehicle_id: "",
            pattern_note: ""
          }
        }]
      }

      // console.log('addToCart params', params);

      const { data } = await axios.post('/cart/add.js', params);

      console.log('addToCart data', data);

      window.location.href = encodeURI('/cart');
    }
  }

  const getVariantForOptions = () => {
    if (selectedColor.name && selectedProductOption) {
      const variants = window.conspire_product.variants;
      const selectedVariant = variants.find(
        v => v.option1 === selectedProductOption && v.option2 === selectedColor.name
      );

      console.log('selectedVariant', selectedVariant);
      setProductVariant(selectedVariant)
    } else {
      setProductVariant({})
    }
  }

  useEffect(() => {
    getVariantForOptions();
  }, [selectedProductOption, selectedColor]);

  return (
    <Grid container>
      <Grid item xs={12} md={8} className="mobile-hide">
        <section className="main-image-container">
          <img src={productImage} alt="Product Image" />
        </section>
        <InfoTabs tabs={tabs} />
      </Grid>
      <Grid item xs={12} md={4}>
        <ProductInfo />
        <section className="main-image-container desktop-hide">
          <img src={productImage} alt="Product Image" />
        </section>
        <FloorMatCarSelector selectedCar={selectedCar} setSelectedCar={setSelectedCar} />
        <ProductOptions
          title="Size"
          options={productOptions}
          productOption={selectedProductOption}
          setProductOption={setSelectedProductOption}
        />
        <h5 className="sheepskin-floor-mats-price">
          {formatMoney(productVariant.price / 100)}
        </h5>
        <ColorSwatches
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
          colors={colors}
          showSelectedColor
          showColorName
          className="sheepskin-floor-mats-color-swatch-container"
        />
        <CartButtons addToCart={addToCart} quantity={quantity} setQuantity={setQuantity} />
        <section className="info-tabs-wrapper desktop-hide">
          <InfoTabs tabs={tabs} />
        </section>
      </Grid>
    </Grid>
  )
}

export default SheepskinFloorMats
